import { Inject, Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';
import { Store, Select } from '@ngxs/store';
import { StorageService, LOCAL_STORAGE } from 'angular-webstorage-service';
import { debounce } from 'lodash';
import { AssetsUpdateService, TrackingService } from '@services/index';
import { AuthService } from '@examsoft/es-login';
import { LayoutState, CloseMenu, OpenNotification, CloseNotification, CloseTimer } from '../../store';

import { TranslationService } from '@examsoft/translation';



@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy{
  @Select(LayoutState.getShowMenu) showMenu$: Observable<boolean>;
  @Select(LayoutState.getShowNotification) showNotification$: Observable<any>;
  @Select(LayoutState.getShowTimer) showTimer$: Observable<any>;

  public loggedIn = false;
  private debouncedSetVh = debounce(this.setVh, 16); //60fps
  public APP_VERSION = `v${window['APP_VERSION']}`;
  public showFooter = { display: 'none' };



  get isReady$() {
    return this.translationService.isReady$;
  }

  constructor(
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private trackingService: TrackingService,
    public authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store,
    private translationService: TranslationService,
    ) {
      this.translationService.initialise();

    this.authService.init().subscribe(() => {
      this.sendToDefaultRoute()
    });


    this.authService.loggedIn.pipe( distinctUntilChanged() )
      .subscribe( data => {
        this.loggedIn = data;
        if(data){
          let user = this.authService.user;
          this.trackingService.ready(
            user.username,
            user['custom:es-id'],
            'logged-in',
            { userAgent: navigator.userAgent }
          );
        }
      });

    this.setVh();
    this.network();
    window.addEventListener('resize', this.debouncedSetVh);
  }

  public sendToDefaultRoute(){
    let currentUrl = window.location.pathname;
    let url;

    if( this.authService.isAdmin() && !currentUrl.match(/\/admin\//) ){
      url = '/admin';
    }else if( !this.authService.isAdmin() && !currentUrl.match(/^\/poll\//)){
      url = '/launcher';
    }

    if(url){
      this.router.navigateByUrl(url);
    }
  }

  public notification:any = {};
  public timerOverlay = false;


  private network(){
    const offlineMsg = this.translationService.get('You are offline.');
    const onlineMsg = this.translationService.get('You are online.');
    if(  !window['navigator'].onLine ){
      this.store.dispatch(new OpenNotification('warning', offlineMsg));
    }
    window.addEventListener('online', (event) => { this.store.dispatch(new CloseNotification('success', onlineMsg)); });
    window.addEventListener('offline', (event) => { this.store.dispatch(new OpenNotification('warning', offlineMsg));  });
    this.showNotification$.subscribe( (data:any) => this.notification = data );
  }

  public closeNotification(){
    const dismissedMsg = this.translationService.get('Dismissed Notification');
    this.store.dispatch( new CloseNotification('info', dismissedMsg) );
  }

  ngOnInit() {
    this.router.events
    .pipe(
      filter((evt) => evt instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      })
    )
    .subscribe(route => {
      this.showFooter.display = location.pathname.match(/admin\/list|login/) ? 'block' : 'none';
    });
  }

  public timerSeconds = this.storage.get('timer') || 0;

	public toggleTimer(data){
    if(data !== null){
      this.storage.set('timer', data);
    }
    this.store.dispatch(new CloseTimer());
  }

  closeMenu(event) {
    let menuOpen$ = this.showMenu$.subscribe(isOpen => {
      if (isOpen) {
        this.store.dispatch(new CloseMenu());
        event.stopPropagation();
      }
    });
    menuOpen$.unsubscribe();
  }

  setVh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.debouncedSetVh);
    this.authService.loggedIn.unsubscribe();
  }


}
